var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import media from '../../utils/media';
export const H4 = styled((_a) => {
    var { asWhite } = _a, others = __rest(_a, ["asWhite"]);
    return React.createElement(Text, Object.assign({}, others));
}).attrs(() => ({
    tag: 'h4',
})) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
  color: ${({ theme, asWhite, color }) => (asWhite ? theme.primaryWhite : color ? color : theme.primaryBlack)};
  letter-spacing: 0.005em;
  padding: 0px;
  margin: 0px;

  ${media.tablet} {
    font-size: 18px;
    line-height: 22px;
  }
  ${media.mobile} {
    font-size: 18px;
    line-height: 22px;
  }
`;
export const RichH4 = styled((_a) => {
    var { asWhite } = _a, others = __rest(_a, ["asWhite"]);
    return React.createElement(RichText, Object.assign({}, others));
}).attrs(() => ({
    tag: 'h4',
})) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
  color: ${({ theme, asWhite, color }) => (asWhite ? theme.primaryWhite : color ? color : theme.primaryBlack)};
  letter-spacing: 0.005em;
  padding: 0px;
  margin: 0px;

  ${media.tablet} {
    font-size: 18px;
    line-height: 22px;
  }
  ${media.mobile} {
    font-size: 18px;
    line-height: 22px;
  }
`;
